import { render, staticRenderFns } from "./ruyxy_config.vue?vue&type=template&id=df710220&scoped=true&"
import script from "./ruyxy_config.vue?vue&type=script&lang=js&"
export * from "./ruyxy_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df710220",
  null
  
)

export default component.exports